<template>
  <div>
    <Editor
      :api-key="editorApiKey"
      :init="editorParams({height: 300})"
      v-model="localText"
    />
  </div>
</template>

<script>

import Editor from '@tinymce/tinymce-vue'

export default {
  components: {Editor},
  props: ['text'],
  data() {
    return {
      localText: '',
      editorApiKey: 'zc3kxtndpmzkkzmiy5z6nvftqwzou0pwryau5q4u02ojy0kl',
    }
  },
  created() {
    this.localText = this.text;
  },
  methods: {
    editorParams(data) {
      let def = {
        language: 'uk',
        plugins: 'code table lists',
        toolbar: 'undo redo | bold italic underline | fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | numlist bullist | outdent indent | forecolor backcolor removeformat | pagebreak | code',
      };
      return {
        ...def,
        ...data
      };
    },
  }
}

</script>
